module.exports = __webpack_public_path__ + "fonts/31E180_4_0.ebe1d70.woff";